import React, { FC, useEffect, useState } from "react";
import CrossIcon from "../../images/CrossIcon.svg";
import { MySelect } from "pages/StepPages/StepTwo/MySelect/MySelect";
import { MyTextarea } from "pages/StepPages/StepTwo/MyTextarea/MyTextarea";
import { MyInput } from "pages/StepPages/StepTwo/MyInput/MyInput";
import { useAppDispatch } from "toolkit/hooks";
import { createNewOrganization } from "toolkit/organizations/organizations.thunks";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { INN_LIMIT, KPP_LIMIT, OGRN_LIMIT } from "constant/index";
import styles from "./AddingOrganization.module.sass";
import {directoryAPI} from "../../libs/apiClient/Directory";

interface AddingOrganizationProps {
	close: () => void;
	title: string;
	parentId?: number;
}

export const AddingOrganization: FC<AddingOrganizationProps> = ({ close, title, parentId }) => {
	const [displayINN, setDisplayINN] = useState<boolean>(false);
	const [displayKPP, setDisplayKPP] = useState<boolean>(false);
	const [displayOGRN, setDisplayOGRN] = useState<boolean>(false);
	const [submitError, setSubmitError] = useState<boolean>(false);
	const [organizationTypeList, setOrganizationTypeList] = useState<any[]>([]);
	const [selectedType, setSelectedType] = useState<{
		id: number | null;
		name: string;
	}>({
		id: null,
		name: "",
	});
	const [inn, setInn] = useState<string>("");
	const [kpp, setKpp] = useState<string>("");
	const [ogrn, setOgrn] = useState<string>("");
	const [fullName, setFullName] = useState<string>("");
	const [shortName, setShortName] = useState<string>("");
	const dispatch = useAppDispatch();
	const [parents, setParents] = useState<any[]>([]);
	const [selectedParent, setSelectedParent] = useState<{
		id: number | null;
		name: string;
	}>({
		id: null,
		name: "",
	});
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		if (parentId) {
			directoryAPI.organizationTypesList({parent:parentId}).then((r) => {
				setOrganizationTypeList(r.data);
			});
		} else {
			directoryAPI.organizationTypesList().then((r) => {
				setOrganizationTypeList(r.data);
			});
		}
		//eslint-disable-next-line
	}, []);

	const displayINNHandler = (): void => {
		setInn("");
		setDisplayINN(!displayINN);
	};

	const displayKPPHandler = (): void => {
		setKpp("");
		setDisplayKPP(!displayKPP);
	};

	const displayOGRNHandler = (): void => {
		setOgrn("");
		setDisplayOGRN(!displayOGRN);
	};

	const changeSelectedType = (type: any) => {
		setSelectedType(type);
		if (parentId) return;
		setSelectedParent({ id: null, name: "" });
		directoryAPI.organizationsParentList({id:type.id}).then((r) => {
			if (r.data.length) {
				const newParents: any[] = [];
				// eslint-disable-next-line array-callback-return
				r.data.map((item: any) => {
					newParents.push({ id: item.id, name: item.shortName });
				});
				setParents(newParents);
			}
		});
	};

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (
			!selectedType.id ||
			!shortName.trim() ||
			!fullName.trim() ||
			(selectedType.name !== "Головная организация" && !selectedParent.id && !parentId)
		) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			setLoading(true);
			dispatch(
				createNewOrganization({
					newOrganization: {
						fullName: fullName,
						inn: inn.trim() || null,
						kpp: kpp.trim() || null,
						ogrn: ogrn.trim() || null,
						parent: parentId || selectedParent.id,
						shortName: shortName,
						type: selectedType.id,
					},
					setLoading,
					close,
				}),
			);
		}
	};

	const validate = (value: string, set: any) => {
		// const regExp = new RegExp(/^[^a-zA-Zа-яА-Я]+$/);
		// if (value.match(regExp) || value === "") {
		// 	set();
		// }

		set();
	};

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>{title}</h4>
			<form onSubmit={submitHandler} className={styles.form}>
				<div className={styles["form-wrp"]}>
					<MySelect
						className={styles.item}
						list={organizationTypeList}
						value={selectedType.name}
						set={(selected) => changeSelectedType(selected)}
						name="Тип организации"
						placeholder="Выберите тип организации"
						width="full"
						required={true}
						error={submitError}
						scroll={false}
						search={false}
					/>
					{selectedType.id !== 1 && !parentId && (
						<MySelect
							className={styles.item}
							list={parents}
							value={selectedParent.name}
							set={(selected) => setSelectedParent(selected)}
							name="Материнская организация"
							placeholder="Выберите материнскую организацию"
							width="full"
							required={true}
							error={submitError}
							disabled={!selectedType.id}
						/>
					)}
					<div className={styles.item}>
						<MyTextarea
							className={styles["area-shortname"]}
							value={shortName}
							set={(e) => setShortName(e.target.value)}
							name="Краткое название"
							placeholder="Общество с ограниченной ответственностью “Черноморская транспортная нефтяная компания Новороссийский филиал”"
							width="full"
							maxLength={150}
							resize="none"
							required={true}
							error={submitError}
						/>
					</div>
					<div className={styles.item}>
						<MyTextarea
							className={styles["area-fullname"]}
							value={fullName}
							set={(e) => setFullName(e.target.value)}
							name="Полное название"
							placeholder="Общество с ограниченной ответственностью “Черноморская транспортная нефтяная компания Новороссийский филиал”"
							width="full"
							resize="vertical"
							required={true}
							error={submitError}
						/>
					</div>
					{displayINN && (
						<div className={styles["item-wrp"]}>
							<MyInput
								name="ИНН"
								placeholder="563565286576"
								value={inn}
								set={(e) => validate(e.target.value, () => setInn(e.target.value))}
								maxLength={INN_LIMIT}
							/>
							<button type="button" onClick={displayINNHandler} className={styles["item-cross"]}>
								<img src={CrossIcon} className={styles["item-cross-icon"]} alt="close" />
							</button>
						</div>
					)}
					{displayKPP && (
						<div className={styles["item-wrp"]}>
							<MyInput
								name="КПП"
								placeholder="7736 01 001"
								value={kpp}
								set={(e) => validate(e.target.value, () => setKpp(e.target.value))}
								maxLength={KPP_LIMIT}
							/>
							<button type="button" onClick={displayKPPHandler} className={styles["item-cross"]}>
								<img src={CrossIcon} className={styles["item-cross-icon"]} alt="close" />
							</button>
						</div>
					)}
					{displayOGRN && (
						<div className={styles["item-wrp"]}>
							<MyInput
								name="ОГРН"
								placeholder="1-02-66-05-60662-0"
								value={ogrn}
								set={(e) => validate(e.target.value, () => setOgrn(e.target.value))}
								maxLength={OGRN_LIMIT}
							/>
							<button type="button" onClick={displayOGRNHandler} className={styles["item-cross"]}>
								<img src={CrossIcon} className={styles["item-cross-icon"]} alt="close" />
							</button>
						</div>
					)}
				</div>
				<div className={styles.managment}>
					{!displayINN && (
						<button onClick={displayINNHandler} className={styles["managment-item"]}>
							+ Добавьте ИНН
						</button>
					)}
					{!displayKPP && (
						<button onClick={displayKPPHandler} className={styles["managment-item"]}>
							+ Добавьте КПП
						</button>
					)}
					{!displayOGRN && (
						<button onClick={displayOGRNHandler} className={styles["managment-item"]}>
							+ Добавьте ОГРН
						</button>
					)}
				</div>
				<div className={styles.btns}>
					<Button
						disabled={loading}
						onClick={close}
						type="button"
						variant={BUTTON_VARIANTS.OUTLINED}
						className={styles.button}>
						Отменить
					</Button>
					<Button loading={loading} type="submit" className={styles.button}>
						Готово
					</Button>
				</div>
			</form>
		</section>
	);
};
